<script lang="ts" setup>
import PipWindow from "@/components/layout/PipWindow.vue";
import CreateBrokerUpdateForm from "@/views/trips/components/forms/CreateBrokerUpdateForm.vue";
import type { CheckCallType } from "@/api/trips/dto/check-call";
import type { TripUpdate } from "@/api/trips/dto/update";

const showDialog = defineModel<boolean>({ default: false });

const props = defineProps<{
  travelOrderId: number;
  checkCallId: number;
  routeId: number;
  checkCallType: CheckCallType;
}>();

const emits = defineEmits<{
  (e: "success", update: TripUpdate, travelOrderId: number): void;
}>();

function onSuccess(update: TripUpdate, travelOrderId: number) {
  emits("success", update, travelOrderId);
}

function onClose() {
  showDialog.value = false;
}
</script>

<template>
  <pip-window v-model="showDialog">
    <create-broker-update-form
      :check-call-id="props.checkCallId"
      :check-call-type="props.checkCallType"
      :route-id="props.routeId"
      :travel-order-id="props.travelOrderId"
      @close="onClose"
      @success="onSuccess"
    />
  </pip-window>
</template>

<style lang="scss" scoped></style>
